import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PeriodService, ScheduleService, TimemanagerDialogService } from '../services';

@Component({
  selector: 'app-timemanager',
  templateUrl: './timemanager.component.html',
  styleUrls: ['./timemanager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimemanagerComponent implements OnInit, OnDestroy, AfterViewInit {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  isScrolled = false;

  @Output()
  scheduleChange: EventEmitter<{ scheduleIds: number[]; periods: any[] }> = new EventEmitter<{
    scheduleIds: number[];
    periods: any[];
  }>();

  @ViewChild('schedulesContainerRef', { static: true })
  schedulesContainerRef: ElementRef;

  constructor(
    public scheduleService: ScheduleService,
    private periodService: PeriodService,
    private timemanagerDialogService: TimemanagerDialogService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.periodService.multipleDaysSelection$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((dayIds) => {
        this.openProgramPeriodDialog(dayIds);
      });
  }

  ngAfterViewInit(): void {
    this.renderer.listen(this.schedulesContainerRef.nativeElement, 'scroll', () =>
      this.setIsScrolled()
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getDays(): string[] {
    return this.scheduleService.getDays();
  }

  getId(id: number): string {
    return this.scheduleService.daysKeys[id];
  }

  openProgramPeriodDialog(dayIds: number[]): void {
    this.scheduleService.saveCurrScheduleEntries();
    const schedules = this.scheduleService.schedules$.getValue();
    this.timemanagerDialogService
      .openScheduleEntryPeriodDialog({ schedule: schedules[dayIds[0]], dayIds })
      .subscribe((dialog) => {
        if (dialog && dialog.action === 'save') {
          this.scheduleService.updateScheduleEntryPeriods(dayIds, dialog.periods[0]);
          this.scheduleChange.emit({
            scheduleIds: dayIds,
            periods: dialog.periods[0],
          });
        }
      });
  }

  setIsScrolled(): void {
    const el = this.schedulesContainerRef.nativeElement;

    if (this.isScrolled !== el.scrollLeft > 0) {
      this.isScrolled = !this.isScrolled;
      this.cdr.markForCheck();
    }
  }
}
